import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import { Chip, FormControl, FormControlLabel, Radio, RadioGroup, Stack, type Theme, Typography } from '@mui/material';
import type { RVAdvisorInvitationApi } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { InvitationListFrame } from './advisor-invitation-list-common';

type LocalInvitationStatus = 'pending' | 'accepted' | 'declined';
type LocalInvitationState = Record<number, LocalInvitationStatus>;

const MultipleRVInvitations = ({
    invitations,
    loading,
    selectedInvitation,
    onSelectInvitation,
    localStatusMap,
}: {
    invitations: RVAdvisorInvitationApi[];
    loading: boolean;
    selectedInvitation: RVAdvisorInvitationApi | null;
    onSelectInvitation: (invitation: RVAdvisorInvitationApi) => void;
    localStatusMap?: LocalInvitationState;
}) => {
    return (
        <InvitationListFrame
            loading={loading}
            invitations={invitations}
            emptyIcon={<MoveToInboxIcon sx={{ width: 40, height: 40, color: 'grey' }} />}
            emptyMessage={_('Aún no hay solicitudes de vinculación')}
        >
            <FormControl sx={{ maxHeight: '150px', overflow: 'scroll', px: 1, width: '100%' }}>
                <RadioGroup sx={{ width: '100%' }}>
                    {invitations.map((invitation, index) => {
                        const localStatus = localStatusMap?.[invitation.id] ?? 'pending';
                        const isProcessed = localStatus !== 'pending';

                        return (
                            <FormControlLabel
                                key={invitation.id}
                                value={invitation.id}
                                checked={selectedInvitation?.id === invitation.id}
                                control={<Radio color='secondary' />}
                                disabled={isProcessed}
                                sx={{
                                    width: '100%',
                                    mr: 0,
                                    '& .MuiFormControlLabel-label': {
                                        flex: 1,
                                    },
                                    opacity: isProcessed ? 0.6 : 1,
                                }}
                                label={
                                    <Stack
                                        p={2}
                                        direction='row'
                                        justifyContent='space-between'
                                        alignItems='center'
                                        sx={{
                                            border: (t: Theme) => `1px solid ${t.palette.divider}`,
                                            mt: index === 0 ? 0 : '-1px',
                                            width: '100%',
                                        }}
                                    >
                                        <Typography
                                            className='mp-mask'
                                            variant='body1'
                                            color='primary'
                                            fontWeight='bold'
                                        >
                                            {invitation.rv.name}
                                        </Typography>
                                        {localStatus === 'accepted' && (
                                            <Chip
                                                label={_('Aceptada')}
                                                color='success'
                                                size='small'
                                                icon={<CheckCircleIcon />}
                                            />
                                        )}
                                        {localStatus === 'declined' && (
                                            <Chip label={_('Rechazada')} color='error' size='small' />
                                        )}
                                    </Stack>
                                }
                                onClick={() => {
                                    if (!isProcessed) {
                                        onSelectInvitation(invitation);
                                    }
                                }}
                            />
                        );
                    })}
                </RadioGroup>
            </FormControl>
        </InvitationListFrame>
    );
};

export default MultipleRVInvitations;
